import { CONTACT } from "../../lib/contact";
import { useT } from "../../i18n/LanguageContext";

export default function Services() {
    const { t } = useT();
    const tracks = t("services.tracks");

    return (
        <section
            id="services"
            data-testid="services-section"
            data-cta-source="services"
            className="bg-surface/60 py-24 md:py-32 lg:py-40 border-y border-warm"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 md:mb-24">
                    <div className="lg:col-span-5 reveal">
                        <p className="overline mb-6">{t("services.overline")}</p>
                        <h2 className="font-serif text-4xl sm:text-5xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05] text-ink">
                            {t("services.headlineA")}{" "}
                            <em className="italic font-light text-terracotta">
                                {t("services.headlineEm")}
                            </em>{" "}
                            {t("services.headlineB")}
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 lg:pt-4 reveal">
                        <p className="text-base md:text-lg leading-relaxed text-secondary">
                            {t("services.intro")}
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {tracks.map((tr, i) => (
                        <article
                            key={tr.title}
                            data-testid={`service-card-${i}`}
                            className="reveal group bg-[var(--sand)] border border-warm p-8 md:p-10 lg:p-12 flex flex-col"
                        >
                            <div className="flex items-baseline justify-between mb-8">
                                <span className="overline text-secondary">{tr.kicker}</span>
                                <span className="font-serif text-terracotta text-2xl italic">
                                    0{i + 1}
                                </span>
                            </div>
                            <h3 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight text-ink">
                                {tr.title}
                            </h3>
                            <p className="mt-5 text-base md:text-lg leading-relaxed text-secondary">
                                {tr.desc}
                            </p>
                            <ul className="mt-8 space-y-3">
                                {tr.deliverables.map((d) => (
                                    <li
                                        key={d}
                                        className="flex gap-3 text-base text-ink/85"
                                    >
                                        <span className="mt-2 inline-block w-3 h-px bg-terracotta shrink-0" />
                                        {d}
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-10 pt-6 border-t border-warm flex items-center justify-between">
                                <span className="font-serif text-xl text-ink">
                                    {tr.cta}
                                </span>
                                <a
                                    href={CONTACT.calendlyHref}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid={`service-card-${i}-cta`}
                                    className="text-sm link-underline text-ink"
                                >
                                    {t("services.enquire")} →
                                </a>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
